import { z } from 'zod'

export const Wo1110GetResultSchema = z.object({
  number: z.string(),
  partyId: z.number(),
  partyName: z.string(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  qty: z.number(),
  deliveryDate: z.coerce.date(),
  productionDate: z.coerce.date(),
  productionWeekNo: z.number().int(),
  date: z.coerce.date(),
  refNo: z.string().nullable(),
  refDate: z.coerce.date().nullable(),
  remark: z.string().nullable(),
  customerItemCode: z.string().nullable(),
  lotNo: z.string().nullable(),
  productionType: z.string().nullable(),
  machine: z.string().nullable(),
  startDate: z.coerce.date().nullable(),
  endDate: z.coerce.date().nullable(),
  status: z.number(),
  isTestProduction: z.boolean(),
})

export type Wo1110GetResultModel = z.input<typeof Wo1110GetResultSchema>
